import { render, staticRenderFns } from "./Teamwork.vue?vue&type=template&id=6ea4096f&scoped=true"
import script from "./Teamwork.vue?vue&type=script&lang=js"
export * from "./Teamwork.vue?vue&type=script&lang=js"
import style0 from "./Teamwork.vue?vue&type=style&index=0&id=6ea4096f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea4096f",
  null
  
)

export default component.exports